var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('answer-block',{attrs:{"answers":_vm.question.answers,"show":_vm.question.show_result},on:{"input":function (e) { return _vm.$emit('input', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }